import {createSvgIcon} from '../create-svg-icon';

export const RectangleIcon = createSvgIcon(
  <path d="M2 4v16h20V4H2zm18 14H4V6h16v12z" />
, 'RectangleOutlined');
